import { render, staticRenderFns } from "./TraxSettingAircraftCrudForm.vue?vue&type=template&id=51e6f45c"
import script from "./TraxSettingAircraftCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxSettingAircraftCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports